import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import IntroTemplate from "../../components/IntroTemplate/IntroTemplate";
import NewsModel from '../../components/NewsModel/NewsModel.js';
import HomeBlog from '../../components/HomeBlog/HomeBlog';
import { getStoredData } from '../../JsonFiles/fetchData';

const NewsRoomPage = () => {
  const { id } = useParams(); // Get the news ID from the URL
  const [news, setNews] = useState(null); // State to store the fetched news item
  const [blog, setBlog] = useState([]); // State to store the fetched blogs
  const [error, setError] = useState(null); // State for handling errors
  const [loading, setLoading] = useState(true); // State to indicate loading status
  const data = getStoredData()?.["10"] ?? {};

  useEffect(() => {
    // Fetch the specific news item by ID
    const fetchNews = async () => {
      try {
        const response = await axios.get(`https://shahbad-enterprises-backend.vercel.app/blog/${id}`);
        setBlog(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching news:', err);
        setError('Failed to fetch news.');
        setLoading(false);
      }
    };

    // Fetch blogs
    const fetchBlogs = async () => {
      try {
        const response = await axios.get('https://shahbad-enterprises-backend.vercel.app/news');
        setNews(response.data);
      } catch (err) {
        console.error('Error fetching blog:', err);
      }
    };

    if (id) {
      fetchNews();
    }
    fetchBlogs(); // Call blogs API
  }, [id]);

  if (loading) {
    return <div>Loading...</div>; // Show a loading message while fetching
  }

  if (error) {
    return <div>Error: {error}</div>; // Display error message
  }

  if (!news) {
    return <div>No news found.</div>; // Handle the case where news is not found
  }

  return (
    <div>
      <IntroTemplate 
        logo={blog.logo} 
        title={blog.title} 
        image={blog.photo} 
      />
      <NewsModel data={blog} />
      <HomeBlog
        title={data.HomeBlogTitle}
        link={data.HomeBlogLink}
        text={data.HomeBlogText}
        blogs={news} // Pass fetched blogs to HomeBlog
      />
    </div>
  );
};

export default NewsRoomPage;
